import { positionChecker } from 'src/util/useModelDesign'
import { I18NText, Position, State, StateObj } from 'src/types'

const genGloveColorCell = (head: string, stateObj: StateObj, partsKey: string) => ({
  head,
  label: stateObj?.label,
  color: stateObj?.color,
  value: stateObj?.value,
  partsKey
})
// 基本項目ロジク
export const getDxMBaseCells = (state: State, position: Position, t: I18NText) => {
  const genGloveBaseCell = (head: string, stateObj: StateObj) => ({ head, label: stateObj?.label, value: stateObj?.value })
  const { isCatcher, isGlove } = positionChecker(position)
  const productNumber = state.baseModel.productNumber
  const baseModelStateObj = {
    label: productNumber,
    value: productNumber
  }
  return [
    genGloveBaseCell('基本モデル', baseModelStateObj),
    genGloveBaseCell('タンナー', state.tanner),
    isGlove && genGloveBaseCell('バックスタイル', state.backStyle),
    genGloveBaseCell('利き腕', state.dominantArm),
    !isCatcher && genGloveBaseCell('ポケットスタイル', state.materialPack),
    genGloveBaseCell('指カバー/指当て', state.fingerGuardType),
    isGlove && genGloveBaseCell('ウェブパーツ', state.webParts),
    isGlove && genGloveBaseCell('薬指リング', state.loopOfRingFinger),
    isGlove && genGloveBaseCell('ハミダシカット', state.hamidashiCut)
  ].filter(Boolean)
}

// ウェブ2ロジック
export const checkDxMWeb2 = (webPartsValue: string): boolean => {
  return false
  //   return ['w26', 'wt6'].includes(webPartsValue)
}

const variablePartsGenerator = (state: State, position: Position, t: I18NText) => {
  const isLeatherIntegratedIndex = state?.hamidashiCut?.value === 'hamidashiCut'
  switch (position) {
    case 'pitcher':
      return [
        genGloveColorCell(t.THUMB1, state.thumbOut, 'thumbOut'),
        genGloveColorCell(t.THUMB2, state.thumbWeb, 'thumbWeb'),
        genGloveColorCell(t.INDEX3, state.indexWeb, 'indexWeb'),
        !isLeatherIntegratedIndex && genGloveColorCell(t.INDEX4, state.indexMiddle, 'indexMiddle')
      ].filter(Boolean)
    case 'infielder':
      const isUBack = state.baseModel.isUBack
      const isNormal = !isUBack
      return [
        isNormal && genGloveColorCell(t.THUMB1, state.thumbOut, 'thumbOut'),
        isNormal && genGloveColorCell(t.THUMB2, state.thumbWeb, 'thumbWeb'),
        isNormal && genGloveColorCell(`${t.INDEX}${isLeatherIntegratedIndex ? '3-1' : '3'}`, state.indexWeb, 'indexWeb'),
        isUBack && genGloveColorCell(t.THUMB1, state.thumbOut, 'thumbOut'),
        isUBack && genGloveColorCell(t.THUMB2_INDEX3, state.thumbWebAndIndexWeb, 'thumbWebAndIndexWeb'),
        !isLeatherIntegratedIndex && genGloveColorCell(t.INDEX4, state.indexMiddle, 'indexMiddle')
      ].filter(Boolean)
    case 'outfielder':
      // ベルト一体型を考慮
      return [
        genGloveColorCell(t.THUMB1, state.thumbOut, 'thumbOut'),
        genGloveColorCell(t.THUMB2, state.thumbWeb, 'thumbWeb'),
        genGloveColorCell(t.INDEX3, state.indexWeb, 'indexWeb'),
        !isLeatherIntegratedIndex && genGloveColorCell(t.INDEX4, state.indexMiddle, 'indexMiddle')
      ].filter(Boolean)
    default:
      return []
  }
}
// グラブ / カラー項目ロジック
export const getDxMGloveColorCells = (state: State, position: Position, t: I18NText) => {
  const needFingerCoverOrPad = state.fingerGuardType?.value !== 'none'
  const needWeb2 = checkDxMWeb2(state?.webParts?.value)
  const isDirectEmbroidery = ['directEmbroidery', 'unselected'].includes(state.specifyLabel.value)
  const isLabel = ['label'].includes(state.specifyLabel.value)
  const isLoopOfRingFinger = state?.loopOfRingFinger?.value === 'loopOfRingFinger'
  return [
    genGloveColorCell(t.CATCH_SURFACE, state.catchFace, 'catchFace'),
    genGloveColorCell(t.WEB, state.web, 'web'),
    needWeb2 && genGloveColorCell(t.WEB2, state.web2, 'web2'),
    genGloveColorCell(t.THUMB_HOOK, state.thumbHook, 'thumbHook'),
    genGloveColorCell(t.LITTLE_HOOK, state.littleHook, 'littleHook'),
    needFingerCoverOrPad && genGloveColorCell(t.FINGER_GUARD, state.indexCover, 'indexCover'),
    genGloveColorCell(t.LININGS, state.linings, 'linings'),
    ...variablePartsGenerator(state, position, t),
    genGloveColorCell(t.MIDDLE5, state.middleIndex, 'middleIndex'),
    genGloveColorCell(t.MIDDLE6, state.middleRing, 'middleRing'),
    genGloveColorCell(t.RING7, state.ringMiddle, 'ringMiddle'),
    genGloveColorCell(t.RING8, state.ringLittle, 'ringLittle'),
    genGloveColorCell(t.LITTLE9, state.littleRing, 'littleRing'),
    genGloveColorCell(t.LITTLE10, state.littleOut, 'littleOut'),
    genGloveColorCell(t.BAND, state.listBelt, 'listBelt'),
    isLoopOfRingFinger && genGloveColorCell(t.LOOP_OF_RING, state.loopOfRingFingerColor, 'loopOfRingFingerColor'),
    genGloveColorCell(t.EDGE, state.edge, 'edge'),
    genGloveColorCell(t.LACE, state.lace, 'lace'),
    genGloveColorCell(t.STITCH, state.stitch, 'stitch'),
    genGloveColorCell(t.HAMIDASHI, state.hamidashi, 'hamidashi'),
    genGloveColorCell('ムートン', state.mouton, 'mouton'),
    isDirectEmbroidery && genGloveColorCell('DxMロゴ1', state.dxmLabelCore, 'dxmLabelCore'),
    isDirectEmbroidery && genGloveColorCell('DxMロゴ2', state.dxmLabel, 'dxmLabel'),
    isLabel && genGloveColorCell('DxMロゴ', state.dxmLabel, 'dxmLabel')
  ].filter(Boolean)
}

// ファーストミット / カラー項目ロジック
export const getDxMFirstMittColorCells = (state: State, t: I18NText) => {
  const genFirstMittColorCell = (head: string, stateObj: StateObj, partsKey: string) => ({
    head,
    label: stateObj?.label,
    color: stateObj?.color,
    value: stateObj?.value,
    partsKey
  })

  const isLoopOfRingFinger = state?.loopOfRingFinger?.value === 'loopOfRingFinger'
  const needFingerCoverOrPad = state.fingerGuardType.value !== 'none'
  const isDirectEmbroidery = ['directEmbroidery', 'unselected'].includes(state.specifyLabel.value)
  const isLabel = ['label'].includes(state.specifyLabel.value)
  return [
    genFirstMittColorCell(t.CATCH_SURFACE, state.catchFace, 'catchFace'),
    genFirstMittColorCell(t.WEB, state.web, 'web'),
    genFirstMittColorCell(t.THUMB_HOOK, state.thumbHook, 'thumbHook'),
    genFirstMittColorCell(t.LITTLE_HOOK, state.littleHook, 'littleHook'),
    needFingerCoverOrPad && genFirstMittColorCell(t.FINGER_GUARD, state.indexCover, 'indexCover'),
    genFirstMittColorCell(t.LININGS, state.linings, 'linings'),
    genFirstMittColorCell(t.THUMB, state.thumb, 'thumb'),
    genFirstMittColorCell(t.UNDER_WEB, state.underWeb, 'underWeb'),
    genFirstMittColorCell(t.BOOMERANG, state.boomerang, 'boomerang'),
    genFirstMittColorCell(t.BAND, state.listBelt, 'listBelt'),
    genFirstMittColorCell('薬指リング', state.loopOfRingFingerColor, 'loopOfRingFingerColor'),
    isLoopOfRingFinger && genFirstMittColorCell(t.LOOP_OF_RING, state.loopOfRingFingerColor, 'loopOfRingFingerColor'), // ベルト必須
    genFirstMittColorCell(t.LACE, state.lace, 'lace'),
    genFirstMittColorCell(t.EDGE, state.edge, 'edge'),
    genFirstMittColorCell(t.STITCH, state.stitch, 'stitch'),
    genFirstMittColorCell('ムートン', state.mouton, 'mouton'),
    isDirectEmbroidery && genFirstMittColorCell('DxMロゴ 1', state.dxmLabelCore, 'dxmLabelCore'),
    isDirectEmbroidery && genFirstMittColorCell('DxMロゴ 2', state.dxmLabel, 'dxmLabel'),
    isLabel && genFirstMittColorCell('DxMロゴ', state.dxmLabel, 'dxmLabel')
  ].filter(Boolean)
}

// キャッチャーミット / カラー項目ロジック
export const getDxMCatcherMittColorCells = (state: State, t: I18NText) => {
  const genCatcherMittColorCell = (head: string, stateObj: StateObj, partsKey: string) => ({
    head,
    label: stateObj?.label,
    color: stateObj?.color || 'No data',
    value: stateObj?.value,
    partsKey
  })

  const needFingerCoverOrPad = state.fingerGuardType.value !== 'none'
  const isDirectEmbroidery = ['directEmbroidery', 'unselected'].includes(state.specifyLabel.value)
  const isLabel = ['label'].includes(state.specifyLabel.value)
  return [
    genCatcherMittColorCell(t.CATCH_SURFACE, state.catchFace, 'catchFace'),
    genCatcherMittColorCell(t.WEB, state.web, 'web'),
    genCatcherMittColorCell(t.THUMB_HOOK, state.thumbHook, 'thumbHook'),
    genCatcherMittColorCell(t.LITTLE_HOOK, state.littleHook, 'littleHook'),
    needFingerCoverOrPad && genCatcherMittColorCell(t.FINGER_GUARD, state.indexCover, 'indexCover'),
    genCatcherMittColorCell(t.LININGS, state.linings, 'linings'),
    genCatcherMittColorCell(t.STAND, state.fingerStand, 'fingerStand'),
    genCatcherMittColorCell(t.EDGE, state.edge, 'edge'),
    genCatcherMittColorCell('親指', state.thumb, 'thumb'),
    genCatcherMittColorCell('人差指・中指1', state.indexMiddleRight, 'indexMiddleRight'),
    genCatcherMittColorCell('中指2・薬指', state.middleLeftRing, 'middleLeftRing'),
    genCatcherMittColorCell('小指', state.little, 'little'),
    genCatcherMittColorCell(t.BAND, state.listBelt, 'listBelt'),
    genCatcherMittColorCell(t.LACE, state.lace, 'lace'),
    genCatcherMittColorCell(t.STITCH, state.stitch, 'stitch'),
    genCatcherMittColorCell(t.HAMIDASHI, state.hamidashi, 'hamidashi'),
    genCatcherMittColorCell(t.TARGET, state.catchFaceTarget, 'catchFaceTarget'),
    genCatcherMittColorCell(t.MOUTON, state.mouton, 'mouton'), // ベルトバックのみ選択できる
    isDirectEmbroidery && genCatcherMittColorCell('DxMロゴ 1', state.dxmLabelCore, 'dxmLabelCore'),
    isDirectEmbroidery && genCatcherMittColorCell('DxMロゴ 2', state.dxmLabel, 'dxmLabel'),
    isLabel && genCatcherMittColorCell('DxMロゴ', state.dxmLabel, 'dxmLabel')
  ].filter(Boolean)
}
